<template>
  <div
    class="item-avatar"
    :class="{
      'large': type === 'large'
    }"
    :style="
      'background-color: ' +
        (name === 'route_person' ? '#819F77' : name === 'route_group' ? '#77A9D7' : '#CC2F2F') +
        ';'
    "
  >
    <img :src="imgUrl" :style="imgStyle" alt="img" />
  </div>
</template>

<script>
export default {
  name: 'TextFlowButtonIcon',
  props: {
    name: String,
    type: String
  },
  computed: {
    imgUrl() {
      const images = require.context('@/assets/images', false, /\.svg$/);
      let imageName = '';
      switch (this.name) {
        case 'route_person':
          imageName = 'person_white';
          break;
        case 'route_group':
          imageName = 'group_white';
          break;
        default:
          break;
      }
      return images('./' + imageName + '.svg');
    },

    imgStyle() {
      let imageStyle;
      if (this.type === 'large') {
        imageStyle += ' transform: scale(1.85);';
      }
      return imageStyle;
    }
  }
};
</script>

<style scoped lang="scss">
.item-avatar {
  width: 25px;
  height: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 5px !important;
  font-weight: 500;
  font-size: 16px;
  line-height: 15px;
  text-align: center;
  letter-spacing: 0.03em;
  color: #ffffff;
}
</style>
